/**
 * Curated Windows-style timezone list (display labels) mapped to IANA identifiers.
 * Used by Admin Settings display timezone picker.
 */
const RAW_WINDOWS_TIMEZONES = [
  ["(UTC-11:00) Coordinated Universal Time-11", "UTC-11", "Etc/GMT+11"],
  ["(UTC-10:00) Aleutian Islands", "Aleutian Standard Time", "America/Adak"],
  ["(UTC-10:00) Hawaii", "Hawaiian Standard Time", "Pacific/Honolulu"],
  ["(UTC-09:30) Marquesas Islands", "Marquesas Standard Time", "Pacific/Marquesas"],
  ["(UTC-09:00) Alaska", "Alaskan Standard Time", "America/Anchorage"],
  ["(UTC-09:00) Coordinated Universal Time-09", "UTC-09", "Etc/GMT+9"],
  ["(UTC-08:00) Baja California", "Pacific Standard Time (Mexico)", "America/Tijuana"],
  ["(UTC-08:00) Coordinated Universal Time-08", "UTC-08", "Etc/GMT+8"],
  ["(UTC-08:00) Pacific Time (US & Canada)", "Pacific Standard Time", "America/Los_Angeles"],
  ["(UTC-07:00) Arizona", "US Mountain Standard Time", "America/Phoenix"],
  ["(UTC-07:00) La Paz, Mazatlan", "Mountain Standard Time (Mexico)", "America/Mazatlan"],
  ["(UTC-07:00) Mountain Time (US & Canada)", "Mountain Standard Time", "America/Denver"],
  ["(UTC-07:00) Yukon", "Yukon Standard Time", "America/Whitehorse"],
  ["(UTC-06:00) Central America", "Central America Standard Time", "America/Guatemala"],
  ["(UTC-06:00) Central Time (US & Canada)", "Central Standard Time", "America/Chicago"],
  ["(UTC-06:00) Easter Island", "Easter Island Standard Time", "Pacific/Easter"],
  ["(UTC-06:00) Guadalajara, Mexico City, Monterrey", "Central Standard Time (Mexico)", "America/Mexico_City"],
  ["(UTC-06:00) Saskatchewan", "Canada Central Standard Time", "America/Regina"],
  ["(UTC-05:00) Bogota, Lima, Quito, Rio Branco", "SA Pacific Standard Time", "America/Bogota"],
  ["(UTC-05:00) Chetumal", "Eastern Standard Time (Mexico)", "America/Cancun"],
  ["(UTC-05:00) Eastern Time (US & Canada)", "Eastern Standard Time", "America/New_York"],
  ["(UTC-05:00) Haiti", "Haiti Standard Time", "America/Port-au-Prince"],
  ["(UTC-05:00) Havana", "Cuba Standard Time", "America/Havana"],
  ["(UTC-05:00) Indiana (East)", "US Eastern Standard Time", "America/Indiana/Indianapolis"],
  ["(UTC-05:00) Turks and Caicos", "Turks And Caicos Standard Time", "America/Grand_Turk"],
  ["(UTC-04:00) Atlantic Time (Canada)", "Atlantic Standard Time", "America/Halifax"],
  ["(UTC-04:00) Caracas", "Venezuela Standard Time", "America/Caracas"],
  ["(UTC-04:00) Cuiaba", "Central Brazilian Standard Time", "America/Cuiaba"],
  ["(UTC-04:00) Georgetown, La Paz, Manaus, San Juan", "SA Western Standard Time", "America/La_Paz"],
  ["(UTC-04:00) Santiago", "Pacific SA Standard Time", "America/Santiago"],
  ["(UTC-03:30) Newfoundland", "Newfoundland Standard Time", "America/St_Johns"],
  ["(UTC-03:00) Araguaina", "Tocantins Standard Time", "America/Araguaina"],
  ["(UTC-03:00) Asuncion", "Paraguay Standard Time", "America/Asuncion"],
  ["(UTC-03:00) Brasilia", "E. South America Standard Time", "America/Sao_Paulo"],
  ["(UTC-03:00) Cayenne, Fortaleza", "SA Eastern Standard Time", "America/Cayenne"],
  ["(UTC-03:00) City of Buenos Aires", "Argentina Standard Time", "America/Buenos_Aires"],
  ["(UTC-03:00) Montevideo", "Montevideo Standard Time", "America/Montevideo"],
  ["(UTC-03:00) Punta Arenas", "Magallanes Standard Time", "America/Punta_Arenas"],
  ["(UTC-03:00) Saint Pierre and Miquelon", "Saint Pierre Standard Time", "America/Miquelon"],
  ["(UTC-03:00) Salvador", "Bahia Standard Time", "America/Bahia"],
  ["(UTC-02:00) Coordinated Universal Time-02", "UTC-02", "Etc/GMT+2"],
  ["(UTC-02:00) Greenland", "Greenland Standard Time", "America/Nuuk"],
  ["(UTC-01:00) Azores", "Azores Standard Time", "Atlantic/Azores"],
  ["(UTC-01:00) Cabo Verde Is.", "Cape Verde Standard Time", "Atlantic/Cape_Verde"],
  ["(UTC) Coordinated Universal Time", "UTC", "Etc/UTC"],
  ["(UTC+00:00) Dublin, Edinburgh, Lisbon, London", "GMT Standard Time", "Europe/London"],
  ["(UTC+00:00) Monrovia, Reykjavik", "Greenwich Standard Time", "Atlantic/Reykjavik"],
  ["(UTC+00:00) Sao Tome", "Sao Tome Standard Time", "Africa/Sao_Tome"],
  ["(UTC+01:00) Casablanca", "Morocco Standard Time", "Africa/Casablanca"],
  ["(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", "W. Europe Standard Time", "Europe/Berlin"],
  ["(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", "Central Europe Standard Time", "Europe/Budapest"],
  ["(UTC+01:00) Brussels, Copenhagen, Madrid, Paris", "Romance Standard Time", "Europe/Paris"],
  ["(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb", "Central European Standard Time", "Europe/Warsaw"],
  ["(UTC+01:00) West Central Africa", "W. Central Africa Standard Time", "Africa/Lagos"],
  ["(UTC+02:00) Athens, Bucharest", "GTB Standard Time", "Europe/Bucharest"],
  ["(UTC+02:00) Beirut", "Middle East Standard Time", "Asia/Beirut"],
  ["(UTC+02:00) Cairo", "Egypt Standard Time", "Africa/Cairo"],
  ["(UTC+02:00) Chisinau", "E. Europe Standard Time", "Europe/Chisinau"],
  ["(UTC+02:00) Gaza, Hebron", "West Bank Standard Time", "Asia/Hebron"],
  ["(UTC+02:00) Harare, Pretoria", "South Africa Standard Time", "Africa/Johannesburg"],
  ["(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", "FLE Standard Time", "Europe/Kyiv"],
  ["(UTC+02:00) Jerusalem", "Israel Standard Time", "Asia/Jerusalem"],
  ["(UTC+02:00) Juba", "South Sudan Standard Time", "Africa/Juba"],
  ["(UTC+02:00) Kaliningrad", "Kaliningrad Standard Time", "Europe/Kaliningrad"],
  ["(UTC+02:00) Khartoum", "Sudan Standard Time", "Africa/Khartoum"],
  ["(UTC+02:00) Tripoli", "Libya Standard Time", "Africa/Tripoli"],
  ["(UTC+02:00) Windhoek", "Namibia Standard Time", "Africa/Windhoek"],
  ["(UTC+03:00) Amman", "Jordan Standard Time", "Asia/Amman"],
  ["(UTC+03:00) Baghdad", "Arabic Standard Time", "Asia/Baghdad"],
  ["(UTC+03:00) Damascus", "Syria Standard Time", "Asia/Damascus"],
  ["(UTC+03:00) Istanbul", "Turkey Standard Time", "Europe/Istanbul"],
  ["(UTC+03:00) Kuwait, Riyadh", "Arab Standard Time", "Asia/Riyadh"],
  ["(UTC+03:00) Minsk", "Belarus Standard Time", "Europe/Minsk"],
  ["(UTC+03:00) Moscow, St. Petersburg", "Russian Standard Time", "Europe/Moscow"],
  ["(UTC+03:00) Nairobi", "E. Africa Standard Time", "Africa/Nairobi"],
  ["(UTC+03:00) Volgograd", "Volgograd Standard Time", "Europe/Volgograd"],
  ["(UTC+03:30) Tehran", "Iran Standard Time", "Asia/Tehran"],
  ["(UTC+04:00) Abu Dhabi, Muscat", "Arabian Standard Time", "Asia/Dubai"],
  ["(UTC+04:00) Astrakhan, Ulyanovsk", "Astrakhan Standard Time", "Europe/Astrakhan"],
  ["(UTC+04:00) Baku", "Azerbaijan Standard Time", "Asia/Baku"],
  ["(UTC+04:00) Izhevsk, Samara", "Russia Time Zone 3", "Europe/Samara"],
  ["(UTC+04:00) Port Louis", "Mauritius Standard Time", "Indian/Mauritius"],
  ["(UTC+04:00) Saratov", "Saratov Standard Time", "Europe/Saratov"],
  ["(UTC+04:00) Tbilisi", "Georgian Standard Time", "Asia/Tbilisi"],
  ["(UTC+04:00) Yerevan", "Caucasus Standard Time", "Asia/Yerevan"],
  ["(UTC+04:30) Kabul", "Afghanistan Standard Time", "Asia/Kabul"],
  ["(UTC+05:00) Ashgabat, Tashkent", "West Asia Standard Time", "Asia/Tashkent"],
  ["(UTC+05:00) Astana", "Qyzylorda Standard Time", "Asia/Qyzylorda"],
  ["(UTC+05:00) Ekaterinburg", "Ekaterinburg Standard Time", "Asia/Yekaterinburg"],
  ["(UTC+05:00) Islamabad, Karachi", "Pakistan Standard Time", "Asia/Karachi"],
  ["(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", "India Standard Time", "Asia/Kolkata"],
  ["(UTC+05:30) Sri Jayawardenepura", "Sri Lanka Standard Time", "Asia/Colombo"],
  ["(UTC+05:45) Kathmandu", "Nepal Standard Time", "Asia/Kathmandu"],
  ["(UTC+06:00) Bishkek", "Central Asia Standard Time", "Asia/Bishkek"],
  ["(UTC+06:00) Dhaka", "Bangladesh Standard Time", "Asia/Dhaka"],
  ["(UTC+06:00) Omsk", "Omsk Standard Time", "Asia/Omsk"],
  ["(UTC+06:30) Yangon (Rangoon)", "Myanmar Standard Time", "Asia/Yangon"],
  ["(UTC+07:00) Bangkok, Hanoi, Jakarta", "SE Asia Standard Time", "Asia/Bangkok"],
  ["(UTC+07:00) Barnaul, Gorno-Altaysk", "Altai Standard Time", "Asia/Barnaul"],
  ["(UTC+07:00) Hovd", "W. Mongolia Standard Time", "Asia/Hovd"],
  ["(UTC+07:00) Krasnoyarsk", "North Asia Standard Time", "Asia/Krasnoyarsk"],
  ["(UTC+07:00) Novosibirsk", "N. Central Asia Standard Time", "Asia/Novosibirsk"],
  ["(UTC+07:00) Tomsk", "Tomsk Standard Time", "Asia/Tomsk"],
  ["(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", "China Standard Time", "Asia/Shanghai"],
  ["(UTC+08:00) Irkutsk", "North Asia East Standard Time", "Asia/Irkutsk"],
  ["(UTC+08:00) Kuala Lumpur, Singapore", "Singapore Standard Time", "Asia/Singapore"],
  ["(UTC+08:00) Perth", "W. Australia Standard Time", "Australia/Perth"],
  ["(UTC+08:00) Taipei", "Taipei Standard Time", "Asia/Taipei"],
  ["(UTC+08:00) Ulaanbaatar", "Ulaanbaatar Standard Time", "Asia/Ulaanbaatar"],
  ["(UTC+08:45) Eucla", "Aus Central W. Standard Time", "Australia/Eucla"],
  ["(UTC+09:00) Chita", "Transbaikal Standard Time", "Asia/Chita"],
  ["(UTC+09:00) Osaka, Sapporo, Tokyo", "Tokyo Standard Time", "Asia/Tokyo"],
  ["(UTC+09:00) Pyongyang", "North Korea Standard Time", "Asia/Pyongyang"],
  ["(UTC+09:00) Seoul", "Korea Standard Time", "Asia/Seoul"],
  ["(UTC+09:00) Yakutsk", "Yakutsk Standard Time", "Asia/Yakutsk"],
  ["(UTC+09:30) Adelaide", "Cen. Australia Standard Time", "Australia/Adelaide"],
  ["(UTC+09:30) Darwin", "AUS Central Standard Time", "Australia/Darwin"],
  ["(UTC+10:00) Brisbane", "E. Australia Standard Time", "Australia/Brisbane"],
  ["(UTC+10:00) Canberra, Melbourne, Sydney", "AUS Eastern Standard Time", "Australia/Sydney"],
  ["(UTC+10:00) Guam, Port Moresby", "West Pacific Standard Time", "Pacific/Port_Moresby"],
  ["(UTC+10:00) Hobart", "Tasmania Standard Time", "Australia/Hobart"],
  ["(UTC+10:00) Vladivostok", "Vladivostok Standard Time", "Asia/Vladivostok"],
  ["(UTC+10:30) Lord Howe Island", "Lord Howe Standard Time", "Australia/Lord_Howe"],
  ["(UTC+11:00) Bougainville Island", "Bougainville Standard Time", "Pacific/Bougainville"],
  ["(UTC+11:00) Chokurdakh", "Russia Time Zone 10", "Asia/Srednekolymsk"],
  ["(UTC+11:00) Magadan", "Magadan Standard Time", "Asia/Magadan"],
  ["(UTC+11:00) Norfolk Island", "Norfolk Standard Time", "Pacific/Norfolk"],
  ["(UTC+11:00) Sakhalin", "Sakhalin Standard Time", "Asia/Sakhalin"],
  ["(UTC+11:00) Solomon Is., New Caledonia", "Central Pacific Standard Time", "Pacific/Guadalcanal"],
  ["(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", "Russia Time Zone 11", "Asia/Kamchatka"],
  ["(UTC+12:00) Auckland, Wellington", "New Zealand Standard Time", "Pacific/Auckland"],
  ["(UTC+12:00) Coordinated Universal Time+12", "UTC+12", "Etc/GMT-12"],
  ["(UTC+12:00) Fiji", "Fiji Standard Time", "Pacific/Fiji"],
  ["(UTC+12:45) Chatham Islands", "Chatham Islands Standard Time", "Pacific/Chatham"],
  ["(UTC+13:00) Coordinated Universal Time+13", "UTC+13", "Etc/GMT-13"],
  ["(UTC+13:00) Nuku'alofa", "Tonga Standard Time", "Pacific/Tongatapu"],
  ["(UTC+13:00) Samoa", "Samoa Standard Time", "Pacific/Apia"],
  ["(UTC+14:00) Kiritimati Island", "Line Islands Standard Time", "Pacific/Kiritimati"],
];

export const WINDOWS_TIMEZONE_OPTIONS = RAW_WINDOWS_TIMEZONES.map(
  ([label, standardName, identifier]) => ({
    label,
    standardName,
    identifier,
    searchText: `${label} ${standardName} ${identifier}`.toLowerCase(),
  }),
);

const BY_IDENTIFIER = new Map(
  WINDOWS_TIMEZONE_OPTIONS.map((opt) => [opt.identifier, opt]),
);

export function findWindowsTimezoneOption(identifier) {
  return BY_IDENTIFIER.get(String(identifier || "").trim()) || null;
}

export function getTimezoneOptionsForPicker(currentIdentifier) {
  const current = String(currentIdentifier || "").trim();
  if (!current || BY_IDENTIFIER.has(current)) {
    return WINDOWS_TIMEZONE_OPTIONS;
  }
  return [
    {
      label: current,
      standardName: "Custom / legacy timezone",
      identifier: current,
      searchText: current.toLowerCase(),
    },
    ...WINDOWS_TIMEZONE_OPTIONS,
  ];
}
